const DATA_TEST_IDS = {
  fragmentsAboutSystem: 'layouts__main-layout_about-system',
  frgmentsAboutSystemDialogClose:
    'layouts__main-layout_about-system_dialog-close',
} as const;

export default DATA_TEST_IDS;
